export const selectFilterMetadata = ({ filterMetaData }) => filterMetaData;

export const selectFilterMetadataDefinition = ({
  filterMetaData: { definition },
}) => {
  return definition;
};
